export enum RolesPermissionsEnum {
    CREATE = "create",
    READ = "read",
    UPDATE = "update",
    DELETE = "delete",
}

export enum RolesPermissionsGuardEnum {
    ROLES = "roles",
    PERMISSIONS = "permissions",
    PERMISSIONS_HEADS = "permissions_heads",
    PERMISSIONS_SECTIONS = "permissions_sections",
}

// Permisos específicos para gestión de roles
export enum RolesGuardEnum {
    ROLES_VIEW = "roles.view",
    ROLES_CREATE = "roles.create",
    ROLES_UPDATE = "roles.update",
    ROLES_DELETE = "roles.delete",
}

// Permiso global de acceso al panel administrativo
export enum AdminGuardEnum {
    ADMIN_ACCESS = "admin.access",
}

export enum StatusGenericEnum {
    ACTIVE = "active",
    INACTIVE = "inactive",
    DELETED = "deleted",
}

export enum PlatformAccessEnum {
    WEB = "web",
    MOBILE = "mobile",
    BOTH = "both",
}
